import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { apiCall } from '../AuthContext';
import { Layers, CheckCircle } from 'lucide-react';

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    setError('');
    try {
      await apiCall('/api/auth/reset-password', { method: 'POST', data: { token, password } });
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (e) {
      setError(e.response?.data?.detail || 'Failed to reset password');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2.5 mb-8">
          <div className="w-8 h-8 rounded-lg overflow-hidden flex items-center justify-center">
            <img src="/logo.png" alt="XLabelSync" className="w-8 h-8 object-cover" />
          </div>
          <span className="font-bold text-lg text-[#0F172A]">XLabelSync</span>
        </Link>
        {done ? (
          <div className="text-center">
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-[#0F172A] mb-2">Password Reset!</h2>
            <p className="text-sm text-slate-500">Redirecting to login...</p>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-[#0F172A] mb-1">Reset password</h1>
            <p className="text-sm text-slate-500 mb-6">Enter your new password below.</p>
            {error && <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-[#0052FF] focus:border-transparent transition-all outline-none text-sm"
                placeholder="New password" data-testid="reset-password-input" />
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required
                className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-[#0052FF] focus:border-transparent transition-all outline-none text-sm"
                placeholder="Confirm password" data-testid="reset-confirm-input" />
              <button type="submit" disabled={loading} data-testid="reset-submit"
                className="w-full bg-[#0052FF] hover:bg-[#0040CC] text-white font-medium rounded-lg py-2.5 text-sm transition-colors disabled:opacity-50">
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
